import React from 'react';

import { flagStyles } from '../settings';

const SvgMX = (): JSX.Element => (
  <img
    style={{
      backgroundPosition: '-3720px 0px',
      ...flagStyles
    }}
    alt=""
  />
);

export default SvgMX;
